import {
  DISLIKED_JOB_STATE_CHANGED_EVENT,
  type DislikedJobStateChangedEvent,
  type DislikedJobStateChangedSubscription,
} from "./dislikedJobStateChangedEventTypes";

export { DISLIKED_JOB_STATE_CHANGED_EVENT } from "./dislikedJobStateChangedEventTypes";
export type {
  DislikedJobStateChangedEvent,
  DislikedJobStateChangedSource,
  DislikedJobStateChangedSubscription,
} from "./dislikedJobStateChangedEventTypes";

function isDislikedJobStateChangedEvent(
  event: Event,
): event is CustomEvent<DislikedJobStateChangedEvent> {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
  const detail = (event as CustomEvent<Partial<DislikedJobStateChangedEvent>>).detail;

  return (
    detail?.eventType === DISLIKED_JOB_STATE_CHANGED_EVENT &&
    typeof detail.jobKey === "string" &&
    typeof detail.isDisliked === "boolean" &&
    (detail.source === "viewjob" || detail.source === "jobcard") &&
    (detail.vjtk === undefined || typeof detail.vjtk === "string")
  );
}

export function dispatchDislikedJobStateChanged(event: DislikedJobStateChangedEvent): void {
  window.dispatchEvent(
    new CustomEvent(DISLIKED_JOB_STATE_CHANGED_EVENT, {
      detail: event,
    }),
  );
}

export function subscribeDislikedJobStateChanged(
  handler: (event: DislikedJobStateChangedEvent) => void,
): DislikedJobStateChangedSubscription {
  const listener = (event: Event) => {
    if (isDislikedJobStateChangedEvent(event)) {
      handler(event.detail);
    }
  };

  window.addEventListener(DISLIKED_JOB_STATE_CHANGED_EVENT, listener);

  return {
    remove: () => {
      window.removeEventListener(DISLIKED_JOB_STATE_CHANGED_EVENT, listener);
    },
  };
}
